import React, { useEffect, useState } from "react";
import Globe from "../Components/Globe";
import useCurrentTime from "../Components/useCurrentTime";
import { SvgIcon } from "../Components/SvgIcons";
import { useSelector } from "react-redux";
import { formatDateLocal, generalPostFunction } from "../Globals/globalFunctions";

function Dashboard() {
	const account = JSON.parse(localStorage.getItem("account"));
	const currentTime = useCurrentTime();
	const [currentDate, setCurrentDate] = useState("");
	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);
	const onlineUsers = useSelector((state) => state.allPlayers.onlineUsers);
	const allPlayerBet = useSelector((state) => state.allPlayers.allPlayerBet);
	const [totalBetData, setTotalBetData] = useState({
		totalbet: 0,
		totalwin: 0,
		ntp: 0,
		ntpPercent: 0,
	});

	useEffect(() => {
		const updateCurrentDate = () => {
			const now = new Date();
			const day = String(now.getDate()).padStart(2, "0");
			const month = String(now.getMonth() + 1).padStart(2, "0");
			const year = now.getFullYear();

			const formattedDate = `${day}-${month}-${year}`;
			setCurrentDate(formattedDate);
		};
		getAllBetAmountTillDate();
		updateCurrentDate();
	}, []);

	const getAllBetAmountTillDate = async () => {
		const now = new Date();
		const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

		const payload = {
			startDate: formatDateLocal(startOfToday),
			endDate: formatDateLocal(now),
			level: account.level,
			username: account.username,
			user_id: account.id,
		};

		if (account.level == 0) {
			const response = await generalPostFunction("gettotalbettilldate", payload, "3040");
			if (response.message == "success") {
				const totalbet = response.result.total.totalbet;
				const totalwin = response.result.total.totalwin;

				setTotalBetData({
					totalbet: totalbet,
					totalwin: totalwin,
					ntp: totalbet - totalwin,
					ntpPercent: (((totalbet - totalwin) / totalbet) * 100).toFixed(2),
				});
			}
		} else {
			const response = await generalPostFunction("getbetdetails_perheirarchy", payload, "3040");
			if (response.message == "success") {
				const totalbet = response.result.reduce((sum, u) => sum + u.total, 0);
				const totalwin = response.result.reduce((sum, u) => sum + u.winrs, 0);

				setTotalBetData({
					totalbet: totalbet,
					totalwin: totalwin,
					ntp: totalbet - totalwin,
					ntpPercent: (((totalbet - totalwin) / totalbet) * 100).toFixed(2),
				});
			}
		}
	};

	useEffect(() => {
		if (allPlayerBet && allPlayerBet.length > 0) {
			getAllBetAmountTillDate();
		}
	}, [allPlayerBet]);
	return (
		<>
			<div className="col-12">
				<div className="row gy-3">
					<div className="col-7">
						<div className="dashboardCardGroup">
							<div className="row gy-3">
								<div className="col-6">
									<div className="dbCard clock">{currentTime}</div>
								</div>
								<div className="col-6">
									<div className="dbCard clock">{currentDate}</div>
								</div>
								<div className="col-xl-6">
									<div className="dbCard">
										<div className="text">
											<p>Total Bet Amount</p>
											<h5>₹ {totalBetData?.totalbet}</h5>
										</div>
										<div className="icon">
											<SvgIcon name="coin" />
										</div>
									</div>
								</div>
								<div className="col-xl-6">
									<div className="dbCard">
										<div className="text">
											<p>Total Won Amount</p>
											<h5>₹ {totalBetData?.totalwin}</h5>
										</div>
										<div className="icon">
											<SvgIcon name="trophy" />
										</div>
									</div>
								</div>
								<div className="col-xl-6">
									<div className="dbCard">
										<div className="text">
											<p>Net Trading Profit (NTP)</p>
											<h5>₹ {totalBetData?.ntp}</h5>
										</div>
										<div className="icon">
											<SvgIcon name="moon" />
										</div>
									</div>
								</div>
								<div className="col-xl-6">
									<div className="dbCard">
										<div className="text">
											<p>NTP Percentage</p>
											<h5>{isNaN(totalBetData?.ntpPercent) ? 0 : totalBetData?.ntpPercent} %</h5>
										</div>
										<div className="icon">
											<SvgIcon name="calculator" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-5">
						<div className="dbCard">
							<div className="text">
								<h4>Registered Users</h4>
								<p style={{ fontWeight: 500, fontSize: "16px" }}>Total number of players signed up</p>
							</div>
							<div className="icon">
								<SvgIcon name="users" />
							</div>
							<div className="col-12" />
							<div className="text mt-1">
								<p>Online Players</p>
								<h5>{onlineUsers?.length || 0}</h5>
							</div>
							<div className="text mt-1">
								<p className="mt-2">Total Players</p>
								<h5>{setAllPlayers?.length || 0}</h5>
							</div>
							<Globe />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Dashboard;
